'use client';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

export const Badge = ({ children, tooltip }: { children: React.ReactNode; tooltip?: string }) => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  return (
    <div
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      className="group inline-flex items-center space-x-1 rounded-lg border border-neutral-200 bg-neutral-100 px-2 py-1 text-sm dark:border-zinc-900 dark:bg-zinc-700"
    >
      {children}
      <AnimatePresence>
        {showTooltip && tooltip && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            className="border-neural-200 absolute -top-10 left-0 min-w-full rounded-lg  bg-black p-1 text-center text-xs text-white dark:border-white/[0.2]"
          >
            {tooltip}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
